import React from "react";
import { CirclesWithBar } from "react-loader-spinner";
import { LoadingContainerFit, LoadingBox } from "./loadingComponents";

function LoadingSmall() {
  return (
    <LoadingContainerFit>
      <LoadingBox>
        <CirclesWithBar
          visible={true}
          height="150"
          width="150"
          color="#ff8787"
          outerCircleColor="#ff8787"
          innerCircleColor="#ff8787"
          barColor="#4fa94d"
          ariaLabel="circles-with-bar-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </LoadingBox>
    </LoadingContainerFit>
  );
}

export default LoadingSmall;
